import { NavLink, Navigate, Route, Routes } from "react-router-dom";

import { useCurrentUser } from "./auth/useCurrentUser.js";
import { ConnectionsPage } from "./pages/ConnectionsPage.js";
import { SchedulerPage } from "./pages/SchedulerPage.js";

// Top nav link styling: muted by default, brand-blue + semibold when active.
const navLinkClasses = ({ isActive }: { isActive: boolean }) =>
  [
    "text-[13px] font-semibold uppercase tracking-[0.08em] transition",
    isActive ? "text-blue" : "text-ink-soft hover:text-ink",
  ].join(" ");

export function App() {
  return (
    <div className="min-h-screen bg-bg text-ink">
      <TopBar />
      <main>
        <Routes>
          <Route path="/" element={<Navigate to="/scheduler" replace />} />
          <Route path="/connections" element={<ConnectionsPage />} />
          <Route path="/scheduler" element={<SchedulerPage />} />
          <Route
            path="*"
            element={
              <div className="mx-auto w-full max-w-[1240px] px-4 py-8 text-sm text-ink-soft sm:px-6 sm:py-10">
                Not found.
              </div>
            }
          />
        </Routes>
      </main>
    </div>
  );
}

// Portal-style top bar: brand mark left, nav links + signed-in email right.
// Clean separator only — no shadow, so the page surface below feels like a
// continuation of the chrome rather than a separate panel.
function TopBar() {
  const userQuery = useCurrentUser();
  const email = userQuery.data?.email ?? null;

  return (
    <header className="border-b border-line bg-white">
      <div className="mx-auto flex h-[64px] max-w-[1240px] items-center justify-between px-4 sm:px-6">
        <a href="/" className="flex items-center gap-2">
          <span className="text-base font-bold uppercase tracking-[0.02em] text-ink">
            Qlik
          </span>
          <span className="text-base font-bold uppercase tracking-[0.02em] text-blue">
            Scheduler
          </span>
        </a>

        <div className="flex items-center gap-6">
          <nav className="flex items-center gap-6" aria-label="Primary">
            <NavLink to="/scheduler" className={navLinkClasses}>
              Scheduler
            </NavLink>
            <NavLink to="/connections" className={navLinkClasses}>
              Connections
            </NavLink>
          </nav>
          {email ? (
            <span
              className="hidden text-[12px] font-medium text-ink-soft sm:inline"
              title={email}
            >
              {email}
            </span>
          ) : null}
        </div>
      </div>
    </header>
  );
}
